import React from 'react';
import BackButton from '../../../../uiToolkit/Buttons/BackButton';
import Breadcrumbs from '../../../../uiToolkit/Breadcrumbs';
import {courseLevelAnalyticsRootText} from '../courseLevelAnalyticRootText';
import PageTitle from '../../../../uiToolkit/PageTitle';
import OverviewGraph from '../../../../uiToolkit/Analytics/OverviewGraph';
import Dropdown from '../../../../uiToolkit/Inputs/Dropdown';
import {FetchCoursesShortListModel} from '../../../../data/models/AI/AiAssistantModels';
import AnalyticsCard from '../../../../uiToolkit/Analytics/AnalyticsCard';
import './styles.css';
import {Outlet} from 'react-router-dom';
import {CourseAnalyticsData} from '../../../../data/models/Gradebook/CourseAnalyticsModels';
import {truncateNumberTo2Decimals} from '../../../../utils/getTimeTextFromSeconds';

const breadcrumbsSteps = (organizationId?: string, courseName?: string) => [
  {
    title: courseLevelAnalyticsRootText.analytics,
    link: `/manage/${organizationId}/analytics`,
  },
  {
    title: courseName || '',
  },
];

interface Props {
  organizationId: string;
  courseAnalyticsData?: CourseAnalyticsData;
  courses: FetchCoursesShortListModel[];
  selectedCourse: string;
  setSelectedCourse: (value: string) => void;
  onBack: () => void;
}

const CourseLevelAnalyticsRootUI = React.memo(
  ({
    organizationId,
    courseAnalyticsData,
    courses,
    selectedCourse,
    setSelectedCourse,
    onBack,
  }: Props) => {
    return courseAnalyticsData ? (
      <div className="CourseLevelAnalyticsContainer">
        <div className="HeadingSection">
          <div className="GraphSection">
            <div className="BreadcrumbsContainer">
              <BackButton overrideOnBack={onBack} />
              <Breadcrumbs
                steps={breadcrumbsSteps(
                  organizationId,
                  courseAnalyticsData?.name,
                )}
              />
            </div>
            <PageTitle title={courseAnalyticsData?.name || ''} />
            <OverviewGraph
              completed={courseAnalyticsData?.finishedLearners || 0}
              inProgress={courseAnalyticsData?.inProgressLearners || 0}
              notStarted={courseAnalyticsData?.notStartedLearners || 0}
              label={courseLevelAnalyticsRootText.learners}
            />
          </div>
          <div className="CoursesAndCardsSection">
            <Dropdown
              options={courses.map(course => ({
                key: course.id,
                value: course.title,
              }))}
              selectedOption={selectedCourse}
              setSelectedOption={setSelectedCourse}
              placeholder={courseLevelAnalyticsRootText.selectCourse}
              enableSearch
            />
            {courseAnalyticsData?.isGradable ? (
              <div className="AnalyticsCardsContainer">
                <AnalyticsCard
                  value={
                    <p>
                      {courseAnalyticsData?.passedAmount
                        ? courseAnalyticsData?.passedAmount
                        : 0}
                    </p>
                  }
                  label={courseLevelAnalyticsRootText.passed}
                />
                <AnalyticsCard
                  value={
                    <p>
                      {courseAnalyticsData?.failedAmount
                        ? courseAnalyticsData?.failedAmount
                        : 0}
                    </p>
                  }
                  label={courseLevelAnalyticsRootText.failed}
                />
                {/* <AnalyticsCard
                  value={
                    <p>
                      0<span className="AnalyticsCardSmallText">h</span>
                      {courseAnalyticsData?.avgScore ? 43 : 0}
                      <span className="AnalyticsCardSmallText">m</span>
                    </p>
                  }
                  label={courseLevelAnalyticsRootText.avgTime}
                /> */}
                <AnalyticsCard
                  value={
                    <p>
                      {courseAnalyticsData?.avgScore &&
                      isNaN(courseAnalyticsData?.avgScore) ? (
                        '-'
                      ) : (
                        <>
                          {truncateNumberTo2Decimals(
                            courseAnalyticsData?.avgScore || 0,
                          )}
                          <span className="AnalyticsCardSmallText">%</span>
                        </>
                      )}
                    </p>
                  }
                  label={courseLevelAnalyticsRootText.avgScore}
                />
              </div>
            ) : (
              <div className="AnalyticsCardsContainer">
                <AnalyticsCard
                  value={
                    <p>
                      {courseAnalyticsData?.finishedLearners
                        ? courseAnalyticsData?.finishedLearners
                        : 0}
                    </p>
                  }
                  label={courseLevelAnalyticsRootText.completed}
                />
                <AnalyticsCard
                  value={
                    <p>
                      {courseAnalyticsData?.inProgressLearners
                        ? courseAnalyticsData?.inProgressLearners
                        : 0}
                    </p>
                  }
                  label={courseLevelAnalyticsRootText.inProgress}
                />
                {/* <AnalyticsCard
                  value={
                    <p>
                      0<span className="AnalyticsCardSmallText">h</span>
                      {courseAnalyticsData?.avgScore ? 43 : 0}
                      <span className="AnalyticsCardSmallText">m</span>
                    </p>
                  }
                  label={courseLevelAnalyticsRootText.avgTime}
                /> */}
                <AnalyticsCard
                  value={<span className="icon-player"></span>}
                  label={courseLevelAnalyticsRootText.participatory}
                />
              </div>
            )}
          </div>
        </div>

        <Outlet
          context={[
            courseAnalyticsData?.isGradable,
            courseAnalyticsData?.name,
            courseAnalyticsData?.passingScore,
          ]}
        />
      </div>
    ) : null;
  },
);

export default CourseLevelAnalyticsRootUI;
